import { Component, Input, OnInit } from '@angular/core';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
/* shows application status and assignment log history */
export class HistoryComponent implements OnInit {

  @Input() historyLog: Array<any>;
  public showLogHistory : boolean = false;
  
  constructor(public utilService: UtilsService) { }

  ngOnInit(): void {
  }
}
